import { render, staticRenderFns } from "./index-it-solution.vue?vue&type=template&id=d74c4fdc&"
import script from "./index-it-solution.vue?vue&type=script&lang=js&"
export * from "./index-it-solution.vue?vue&type=script&lang=js&"
import style0 from "./index-it-solution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports